export default {
  header: {
    notes: 'Header for spare part catalog page',
    message: 'Spare part catalogue',
  },
  item: {
    position: {
      notes: 'Label for field "position" on spare part catalog items',
      message: 'Position',
    },
  },
};
